import { render, staticRenderFns } from "./DamageLocator.vue?vue&type=template&id=3533aafd&scoped=true&"
import script from "./DamageLocator.vue?vue&type=script&lang=ts&"
export * from "./DamageLocator.vue?vue&type=script&lang=ts&"
import style0 from "./DamageLocator.vue?vue&type=style&index=0&id=3533aafd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3533aafd",
  null
  
)

export default component.exports